//测试接口
const head = "/api/mice";
let mice = {
    getMice(putaway) {
        return `${head}/putaway/${putaway}`;
    }
}
export default mice;